import {z} from 'zod'

import {CreateOrUpdateBlockVehicleDataDocument} from '@sdox/api'

import {updateMetaSchema} from '../../utils/getUpdateMetaFromFieldValues'
import {stringToJSONSchema} from '../../utils/jsonSchema'
import {createFormConfig} from '../../utils/createFormConfig'

import type {BlockVehicleDataInput, CreateOrUpdateBlockVehicleDataMutation, XcNwBlock_VehicleDataTableSectionTypeBlockRowType_Fragment} from '@sdox/api'

type UpdateVehicleDataTableValidatorSchema = z.infer<typeof updateVehicleDataTableValidatorSchema>

const dataSchema = z.array(
  z.object({
    name: z.string(),
    keyValues: z.array(z.object({
      key: z.string(),
      value: z.string(),
    })),
  }),
)

const updateVehicleDataTableValidatorSchema = z.object({
  data: z.object({
    json: stringToJSONSchema.pipe(dataSchema),
  }),
  meta: updateMetaSchema,
})

export const vehicleDataTableConfig = createFormConfig<
  UpdateVehicleDataTableValidatorSchema,
  CreateOrUpdateBlockVehicleDataMutation,
  BlockVehicleDataInput[],
  XcNwBlock_VehicleDataTableSectionTypeBlockRowType_Fragment
>({
  mutationOptions: {
    mutation: CreateOrUpdateBlockVehicleDataDocument,
  },
  validatorSchema: updateVehicleDataTableValidatorSchema,
  fieldMapper: (fieldValues) => fieldValues.data.json,
  inputFields: [
    {
      label: 'Table Section',
      inputType: 'json',
      required: true,
      fieldName: 'data.json',
      defaultValue: JSON.stringify([
        {
          'name': 'test',
          'keyValues': [{'key': 'key', 'value': 'value'}],
        },
      ], null, 2),
      description: 'JSON of a Vehicle Data Table',
      placeholder: '',
      schema: z.array(z.object({
        name: z.string(),
        keyValues: z.array(z.object({
          key: z.string(),
          value: z.string(),
        })),
      })),
    },
  ],
  getDefaultValues: (block) => {
    const input: BlockVehicleDataInput[] = block.items.map(
      (item)  => ({
        name: item.title,
        keyValues: item.items.map(({key, value}) => ({key, value})),
      }),
    )

    return {
      data: {
        json: JSON.stringify(input, null, 2),
      },
      meta: {
        pullout: block.pullout,
        countryCodes: block.countryCodes,
      },
    }
  },
})
